/* Progressive enhancement of supplier charts. Never convert the already-rounded
   display, size labels, diagrams, directions or tolerance notices. */
(function () {
  if (window.sfSizeGuides) return;
  var charts = [];
  var preferred = 'in';
  try { if (sessionStorage.getItem('sf-size-unit') === 'cm') preferred = 'cm'; } catch (e) {}

  function measurement(text) {
    var match = text.trim().match(/^(\d+(?:\.\d+)?)(?:\s*[-–—]\s*(\d+(?:\.\d+)?))?$/);
    return match ? match.slice(1).filter(Boolean).map(Number) : null;
  }
  function display(chart, unit) {
    chart.cells.forEach(function (cell) {
      cell.el.textContent = unit === 'in' ? cell.original : cell.values.map(function (v) {
        return String(Math.round(v * 2.54 * 2) / 2);
      }).join('–');
    });
    chart.caption.textContent = unit === 'in' ? chart.originalCaption : 'Units: centimetres';
    chart.note.textContent = unit === 'in'
      ? 'Table measurements in inches, as supplied.'
      : 'Approximate measurements in centimetres, rounded to the nearest 0.5 cm.';
    chart.controls.querySelectorAll('button').forEach(function (button) {
      button.setAttribute('aria-pressed', button.dataset.sfUnit === unit ? 'true' : 'false');
    });
  }
  function init(scope) {
    scope.querySelectorAll('.sg-card table, .size-guide-section table').forEach(function (table) {
      if (table.dataset.sfUnits) return;
      var caption = table.querySelector('caption');
      if (!caption || !/^units:\s*inches\s*$/i.test(caption.textContent.trim())) return;
      var cells = Array.from(table.querySelectorAll('tbody td')).map(function (el) {
        var original = el.textContent.trim();
        return { el: el, original: original, values: measurement(original) };
      });
      // Unknown supplier markup stays exactly as supplied, without a misleading toggle.
      if (!cells.length || cells.some(function (cell) { return !cell.values; })) return;
      table.dataset.sfUnits = 'ready';
      table.id = table.id || 'sf-size-table-' + charts.length;
      var controls = document.createElement('div');
      controls.className = 'sf-unit-controls';
      controls.setAttribute('role', 'group');
      controls.setAttribute('aria-label', 'Size chart units');
      [['in', 'Inches'], ['cm', 'Centimetres']].forEach(function (choice) {
        var button = document.createElement('button');
        button.type = 'button';
        button.dataset.sfUnit = choice[0];
        button.textContent = choice[1];
        button.setAttribute('aria-controls', table.id);
        controls.appendChild(button);
      });
      var note = document.createElement('p');
      note.className = 'sf-unit-note';
      note.setAttribute('role', 'status');
      note.setAttribute('aria-live', 'polite');
      table.before(controls, note);
      var chart = { cells: cells, caption: caption, originalCaption: caption.textContent, controls: controls, note: note };
      charts.push(chart);
      controls.addEventListener('click', function (event) {
        var button = event.target.closest('[data-sf-unit]');
        if (!button) return;
        preferred = button.dataset.sfUnit;
        try { sessionStorage.setItem('sf-size-unit', preferred); } catch (e) {}
        charts = charts.filter(function (item) { return item.caption.isConnected; });
        charts.forEach(function (item) { display(item, preferred); });
      });
      display(chart, preferred);
    });
  }
  window.sfSizeGuides = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
